import { GridApi, GridReadyEvent } from '@ag-grid-community/core';
import { Component, HostBinding, OnDestroy, ViewEncapsulation } from '@angular/core';
import { fromEvent, Subscription } from 'rxjs';
import { AgGridModule } from '@ag-grid-community/angular';
import { NgIf } from '@angular/common';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { TranslateModule } from '@ngx-translate/core';

import { pageTransitions } from '../../../../../../../shared/animations/page-transitions';
import { CommonColDef } from '../../../../../../../shared/datacenter/column-defs';
import { clientSideAgGridModules, CommonGridOptions } from '../../../../../../../shared/datacenter/grid-options';
import { TranslationService } from '../../../../../../../shared/services/translation.service';
import { DragDropServices } from '../../../../../../models/user-service';
import { AddUserService } from '../../../../../../services/add-user.service';

const resizeObservable = fromEvent(globalThis, 'resize');
@Component({
	selector: 'copo-step-confirmation.component',
	templateUrl: './step-confirmation.component.html',
	styleUrl: './step-confirmation.component.css',
	animations: pageTransitions,
	encapsulation: ViewEncapsulation.Emulated,
	imports: [
		TranslateModule,

		MatCheckboxModule,
		NgIf,
		AgGridModule,
	],
})
export class StepConfirmationComponent implements OnDestroy {
	@HostBinding('class.passthrough') readonly passthrough = true;
	firstName?: string;
	lastName?: string;
	email?: string;
	userType?: string;
	sub?: Subscription;
	addedServices: DragDropServices[] = [];
	gridApi?: GridApi;
	administrator = false;
	readonly modules = clientSideAgGridModules;
	gridOptions: CommonGridOptions<DragDropServices>;

	private resizeSub?: Subscription;

	constructor(
		private readonly addUserService: AddUserService,
		private readonly translationService: TranslationService
	) {
		this.gridOptions = new CommonGridOptions<DragDropServices>({
			translationService: this.translationService,
			multiSortKey: 'ctrl',
			domLayout: 'autoHeight',
			columnDefs: [
				new CommonColDef<DragDropServices>({
					headerName: this.translationService.getTR('user.card.services.tab.name'),
					field: 'name',
				}),
				new CommonColDef<DragDropServices>({
					headerName: this.translationService.getTR('user.card.services.tab.desc'),
					field: 'description',
				}),
			]
		});
		this.sub = this.addUserService.services.subscribe(services => {
			this.addedServices = services;
		});
		this.sub = this.addUserService.administrator.subscribe(administrator => {
			this.administrator = administrator;
		});
		this.sub = this.addUserService.firstName
			.subscribe(firstName => {
				this.firstName = firstName;
			});
		this.sub = this.addUserService.lastName
			.subscribe(lastName => {
				this.lastName = lastName;
			});
		this.sub = this.addUserService.email
			.subscribe(email => {
				this.email = email;
			});
		this.sub = this.addUserService.userType
			.subscribe(userType => {
				this.userType = userType;
			});
	}

	ngOnDestroy() {
		if (this.sub !== undefined) {
			this.sub.unsubscribe();
		}
	}

	onGridReady(params: GridReadyEvent) {
		this.gridApi = params.api;
		params.api.sizeColumnsToFit();
		const resizeSub = resizeObservable.subscribe(() => {
			params.api.sizeColumnsToFit();
		});
		if (!this.resizeSub) {
			this.resizeSub = resizeSub;
		} else {
			this.resizeSub.add(resizeSub);
		}
	}
}
